import { useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { userPrivileges } from '../../../apollo/cache';
import PrivilegeNames from '../../../constants/privilegeNames';

const UserManagementRedirect = () => {
  const privileges = useReactiveVar(userPrivileges);
  const navigate = useNavigate();
  const { orgId, isFree } = useParams();

  useEffect(() => {
    if (orgId && isFree) {
      const licenseType = isFree == 'true' ? 'free-licenses' : 'paid-licenses';
      const urlSuffix = privileges.includes(PrivilegeNames.OrganizationSearch_Advanced)
        ? `/${orgId}`
        : '';
      const url = `/user-management${urlSuffix}#${licenseType}`;

      navigate(url);
    }
  }, [privileges, navigate, orgId, isFree]);

  return null;
};

export default UserManagementRedirect;
